import { TForeignTradeByRegionsState } from './types';

export function setRegionAggregated(
  state: TForeignTradeByRegionsState,
  data: TForeignTradeByRegionsState['regionAggregated'],
) {
  state.regionAggregated = data;
}
